import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  write = (key: string, value: any): void => {
    if (typeof value !== 'string') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  };

  read = <T>(key: string): T | string => {
    const value: string = localStorage.getItem(key);

    try {
      return JSON.parse(value) as T;
    } catch (ex) {
      console.error(ex);
      return value;
    }
  }

  delete = (key: string): void => localStorage.removeItem(key);

  clear = (): void => localStorage.clear();
}
